var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SRGBColorSpace } from "three";
import { Cartographic, Rectangle } from "../../math";
import { DebugDraw } from "../../renderer/debug";
import { TextureLoader } from "../loaders";
import { BaseImageryProvider } from "./BaseImageryProvider";
/**
 * An implementation of ITileProvider that fetches tiles from a URL based on some set of base URLs and a path pattern
 * that is templated based on the zoom level, x and y coordinate of a specific tile.
 */
export class HTTPImageryProvider extends BaseImageryProvider {
    /**
     * Constructs a new HTTPTileProvider with the provided parameters.
     * @param tilingScheme
     * @param options
     */
    constructor(tilingScheme, options) {
        var _a, _b, _c, _d;
        super();
        this._tilingScheme = tilingScheme;
        this._minLevel = options.minLevel;
        this._maxLevel = options.maxLevel;
        this._origin = (_b = (_a = options.origin) === null || _a === void 0 ? void 0 : _a.clone()) !== null && _b !== void 0 ? _b : new Cartographic();
        this._boundingBox = (_d = (_c = options.boundingBox) === null || _c === void 0 ? void 0 : _c.clone()) !== null && _d !== void 0 ? _d : Rectangle.MAX;
        if (this._tilingScheme.rectangle.intersects(this._boundingBox)) {
            this._boundingBox = this._tilingScheme.rectangle.intersection(this._boundingBox);
        }
        else {
            throw new Error("The requested 'region' does not intersect with 'tilingScheme.rectangle'");
        }
    }
    get attributions() {
        return [];
    }
    get minLevel() {
        return this._minLevel;
    }
    get maxLevel() {
        return this._maxLevel;
    }
    get tilingScheme() {
        return this._tilingScheme;
    }
    get origin() {
        return this._origin;
    }
    get region() {
        return this._boundingBox;
    }
    loadTile(x, y, zoomLevel) {
        return __awaiter(this, void 0, void 0, function* () {
            // We can skip sending network requests to find if data is available or not by checking our zoom range and
            // bounding box
            if (this.hasDataForTile(x, y, zoomLevel)) {
                const texture = yield TextureLoader.load(this.resolveTilePath(x, y, zoomLevel), this.resolveRequestOptions());
                // @ts-ignore
                texture.colorSpace = SRGBColorSpace;
                return [
                    {
                        texture,
                        zoomLevel,
                        x,
                        y,
                    },
                ];
            }
            else {
                throw new Error("Requested a tile that does not exist in the dataset bounds");
            }
        });
    }
    debugDraw(worldTransform) {
        // Just using WGS_84 here isn't technically correct but it's just for debug visualization and we're only ever
        // going to use WGS_84 in practice.
        DebugDraw.addGeographicBounds(this._tilingScheme.ellipsoid, this._boundingBox.west, this._boundingBox.south, this._boundingBox.east, this._boundingBox.north, 0, 10, worldTransform);
    }
}
